import { useState } from 'react';

interface InfoBannerProps {
  message: string;
}

export default function InfoBanner({ message }: InfoBannerProps) {
  const [isVisible, setIsVisible] = useState(true);
  
  if (!isVisible) return null;
  
  return (
    <div className="bg-blue-50 rounded-2xl p-4 shadow-sm border border-blue-100 flex items-start gap-3">
      <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
        <i className="ri-information-line text-lg" style={{ color: '#006491' }}></i>
      </div>
      
      <p className="flex-1 text-sm text-gray-700 leading-relaxed">
        {message}
      </p>
      
      <button
        onClick={() => setIsVisible(false)}
        className="w-6 h-6 flex items-center justify-center flex-shrink-0 text-gray-400 hover:text-gray-600 transition-colors"
      >
        <i className="ri-close-line text-lg"></i>
      </button>
    </div>
  );
}
